import script from "./SubscriptionWasntUpdatedDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionWasntUpdatedDialog.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionWasntUpdatedDialog.vue?vue&type=style&index=0&id=16c4c78c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c4c78c"]])

export default __exports__